import LocalStorage from '@occc-app/lib/LocalStorage';
import { Published_Status_Type } from '@occc/graphql';

export const CAMPAIGN_COMPONENTS_FILTERS_STORAGE_KEY = 'campaign-components-filters';

export type PersistedCampaignComponentsFilters = {
  publishedStatus: Published_Status_Type[];
};

const PUBLISHED_STATUSES = Object.values(Published_Status_Type);

const isPublishedStatus = (value: unknown): value is Published_Status_Type =>
  PUBLISHED_STATUSES.includes(value as Published_Status_Type);

const readStoredCampaignId = (): unknown => {
  const stored = LocalStorage.get(CAMPAIGN_COMPONENTS_FILTERS_STORAGE_KEY);
  return stored && typeof stored === 'object'
    ? (stored as Record<string, unknown>).campaignId
    : undefined;
};

export const loadCampaignComponentsFilters = (
  campaignId: string,
): PersistedCampaignComponentsFilters | undefined => {
  const stored = LocalStorage.get(CAMPAIGN_COMPONENTS_FILTERS_STORAGE_KEY);
  if (!stored || typeof stored !== 'object') {
    return undefined;
  }

  const { campaignId: storedCampaignId, publishedStatus } = stored as Record<string, unknown>;
  if (storedCampaignId !== campaignId) {
    return undefined;
  }
  if (!Array.isArray(publishedStatus) || !publishedStatus.every(isPublishedStatus)) {
    return undefined;
  }

  return { publishedStatus };
};

export const saveCampaignComponentsFilters = (
  campaignId: string,
  filters: PersistedCampaignComponentsFilters,
): void => {
  LocalStorage.set(CAMPAIGN_COMPONENTS_FILTERS_STORAGE_KEY, {
    campaignId,
    publishedStatus: filters.publishedStatus,
  });
};

export const clearCampaignComponentsFilters = (): void => {
  LocalStorage.remove(CAMPAIGN_COMPONENTS_FILTERS_STORAGE_KEY);
};

// Discards rather than ignores: the other campaign may never apply a filter of its own,
// and then returning to the first campaign would resurrect a stale selection.
export const clearOtherCampaignComponentsFilters = (campaignId: string): void => {
  if (readStoredCampaignId() !== campaignId) {
    clearCampaignComponentsFilters();
  }
};
